import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { useDrag } from 'react-dnd';
import ItemTypes from './ItemTypes';
import { getEmptyImage } from 'react-dnd-html5-backend';

import { StyledDraggableBox } from './WallVisualizerGalleryStyles';

var DraggableBox = function DraggableBox(_ref) {
  var box = _ref.box,
      dispatch = _ref.dispatch,
      children = _ref.children;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isDragging = _useState2[0],
      setIsDragging = _useState2[1];

  var _useDrag = useDrag({
    item: {
      type: ItemTypes.BOX,
      variantId: box.variantId,
      left: box.left,
      top: box.top,
      img: box.img,
      alt: box.alt,
      width: box.width
    },
    begin: function begin() {
      setIsDragging(true);
    },
    end: function end(item, monitor) {
      setIsDragging(false);
      if (!monitor.didDrop()) {
        // outside of container
        dispatch({
          type: 'REMOVE_BOX_BY_VARIANT_ID',
          variantId: item.variantId
        });
      }
    }
  }),
      _useDrag2 = _slicedToArray(_useDrag, 3),
      drag = _useDrag2[1],
      preview = _useDrag2[2];

  useEffect(function () {
    // this hides the default dragging box and uses customDragLayer instead
    preview(getEmptyImage(), { captureDraggingState: true });
  }, [preview]);

  return React.createElement(
    StyledDraggableBox,
    {
      ref: drag,
      left: box.left,
      top: box.top,
      isDragging: isDragging,
      zIndex: box.zIndex,
      width: box.width
    },
    children
  );
};

DraggableBox.propTypes = {
  box: PropTypes.object.isRequired,
  children: PropTypes.element.isRequired,
  dispatch: PropTypes.func.isRequired
};

export default DraggableBox;